export const isEdgeBrowser = () =>
  typeof navigator !== "undefined" && /Edg/i.test(navigator.userAgent || "");

export const getCurrentPageUrl = () => {
  if (typeof window === "undefined" || !window.location) return "";
  const { origin, pathname, href } = window.location;
  if (origin && pathname) {
    return `${origin}${pathname}`;
  }
  return href || "";
};
